"use strict";

function initIFrameResize() {
  const iframeResizeSelector = '.use_iFrameResize';
  const iframesForResize = document.querySelectorAll(iframeResizeSelector);
  if (iframesForResize.length) {
    if (window.iFrameResize) {
      window.iFrameResize({
        checkOrigin: false
      }, iframeResizeSelector);
    } else {
      console.warn('iFrameResizer was not initialized, so iframe/s dimensions are not adjusted.');
    }
  }
}
['DOMContentLoaded', 'PremiumArticleContentLoaded'].forEach(event => {
  document.addEventListener(event, initIFrameResize);
});
function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

// TODO: use or remove when strive coupons are finalized
// async function initStriveEmbed(templateElement) {
//     const embedPage = templateElement.innerHTML;
//     const userToken = window.getUserToken();
//     let embedUrl = "";

//     if (userToken) {
//         try {
//             const response = await fetch(
//                 `${window.baseApiUrl}/strive/get-embed-url?url=${embedPage}`,
//                 {
//                     method: "GET",
//                     headers: {
//                         'Authorization': `Bearer ${userToken}`,
//                         'Content-Type': 'application/json'
//                     }
//                 }
//             );

//             if (response.ok) {
//                 const data = await response.json();
//                 embedUrl = data?.embed_url;
//             }
//         } catch (error) {
//             console.error(error);
//         }
//     }

//     if (embedUrl) {
//         const iframe = document.createElement('iframe');
//         iframe.className = templateElement.classList[0];
//         iframe.src = embedUrl;
//         iframe.width = '100%';
//         iframe.height = '600px';
//         templateElement.replaceWith(iframe);
//     }
// }

window.addEventListener('DOMContentLoaded', () => {
  const articleContentWrap = document.querySelector('.article__content_wrap');
  if (articleContentWrap.classList.contains('is-locked')) {
    const articlebanners = document.querySelectorAll('.js_bannerInArticle');
    articlebanners?.forEach(banner => banner.remove());
  } else {
    const articleParagraphs = document.querySelectorAll('.is-article .article__content > p');
    if (articleParagraphs.length) {
      const midasWidget = document.querySelector('.js_midasReplacement');
      if (midasWidget) {
        const secondParagraph = articleParagraphs[1];
        const ezoicMidasBannerWrapper = document.querySelector('.js_midasEzoicWrapper');
        insertAfter(midasWidget, secondParagraph);
        if (!window.isMob) {
          if (ezoicMidasBannerWrapper) {
            ezoicMidasBannerWrapper.appendChild(window.getEzoicScriptElement(674));
          }
        } else {
          ezoicMidasBannerWrapper?.remove();
        }
      }
      const admiralAds = document.querySelector('.js_admiralAdsReplacement');
      if (admiralAds && articleParagraphs.length > 5) {
        insertAfter(admiralAds, articleParagraphs[5]);
      }
      const lesninaAds = document.querySelector('.js_lesninaWidget');
      if (lesninaAds && articleParagraphs.length > 2) {
        insertAfter(lesninaAds, articleParagraphs[2]);
      }
    }
  }
  const ezoicInsterscrollerBannerWrapper = document.querySelector('.js_interscrollerEzoicWrapper');
  if (window.isMob && ezoicInsterscrollerBannerWrapper) {
    ezoicInsterscrollerBannerWrapper.appendChild(window.getEzoicScriptElement(680));
  }

  // TODO: use or remove when strive coupons are finalized
  // const striveEmbeds = articleContentWrap.querySelectorAll('div.strivecloud-embed');
  // striveEmbeds.forEach(embed => initStriveEmbed(embed));
});